import React from 'react';
import styled from 'styled-components';

// Icons
const ChartIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10"></line>
    <line x1="12" y1="20" x2="12" y2="4"></line>
    <line x1="6" y1="20" x2="6" y2="14"></line>
  </svg>
);

const HandshakeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 17.5l.41-.17a1 1 0 0 1 1.36.34l1.46 2.5a1 1 0 0 0 1.15.5l2.51-.7a1 1 0 0 0 .7-1.22l-1.1-4.3a1 1 0 0 1 .25-1.01l2-2a1 1 0 0 1 1.5 0l1.5 1.5a1 1 0 0 1 0 1.5l-5 5a1 1 0 0 1-1.5 0l-2-2a1 1 0 0 1 0-1.5l.5-.5"></path>
    <path d="M13 17.5l-.41-.17a1 1 0 0 0-1.36.34l-1.46 2.5a1 1 0 0 1-1.15.5l-2.51-.7a1 1 0 0 1-.7-1.22l1.1-4.3a1 1 0 0 0-.25-1.01l-2-2a1 1 0 0 0-1.5 0l-1.5 1.5a1 1 0 0 0 0 1.5l5 5a1 1 0 0 0 1.5 0l2-2a1 1 0 0 0 0-1.5l-.5-.5"></path>
  </svg>
);

const LightningIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
  </svg>
);

const ShieldIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
  </svg>
);

const GlobeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="2" y1="12" x2="22" y2="12"></line>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
  </svg>
);

const SmartphoneIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
    <line x1="12" y1="18" x2="12.01" y2="18"></line>
  </svg>
);

const PayrollIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
    <line x1="8" y1="21" x2="16" y2="21"></line>
    <line x1="12" y1="17" x2="12" y2="21"></line>
    <circle cx="7" cy="8" r="1"></circle>
    <circle cx="12" cy="8" r="1"></circle>
    <circle cx="17" cy="8" r="1"></circle>
    <line x1="7" y1="12" x2="17" y2="12"></line>
  </svg>
);

const InvestmentIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22,12 18,12 15,21 9,3 6,12 2,12"></polyline>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

const Section = styled.section`
  padding: 5rem 5%;
  background: #ffffff;
  color: #0A3B2D;
  position: relative;
  overflow: hidden;
  margin-top: -1px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
      radial-gradient(circle at 20% 20%, rgba(10, 59, 45, 0.02) 0%, transparent 50%),
      radial-gradient(circle at 80% 80%, rgba(76, 175, 80, 0.02) 0%, transparent 50%);
    pointer-events: none;
    z-index: 1;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 4rem;
  position: relative;
  z-index: 2;
`;

const SectionTitle = styled.h2`
  font-size: 2.75rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #0A3B2D;
  font-family: 'Space Grotesk', sans-serif;
  letter-spacing: -0.02em;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, #0A3B2D 0%, #4CAF50 100%);
    border-radius: 2px;
  }
`;

const SectionSubtitle = styled.p`
  font-size: 1.2rem;
  color: #2a5e4f;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.7;
  font-weight: 400;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2.5rem;
  margin-top: 3rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const Card = styled.div`
  background: linear-gradient(135deg, #ffffff 0%, #f8faf9 100%);
  border: 1px solid #e0e9e6;
  border-radius: 20px;
  padding: 2.5rem 2rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(10, 59, 45, 0.08);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.8) 0%, rgba(248, 250, 249, 0.8) 100%);
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: 1;
  }

  &:hover {
    transform: translateY(-8px) scale(1.02);
    border-color: #0A3B2D;
    box-shadow:
      0 20px 40px rgba(10, 59, 45, 0.15),
      0 8px 16px rgba(10, 59, 45, 0.1);

    &::before {
      opacity: 1;
    }
  }

  & > * {
    position: relative;
    z-index: 2;
  }
`;

const Icon = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 16px;
  background: linear-gradient(135deg, #f0f7f4 0%, #e8f5e8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  color: #0A3B2D;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(10, 59, 45, 0.1);

  svg {
    width: 28px;
    height: 28px;
    stroke-width: 1.5;
    transition: transform 0.3s ease;
  }

  ${Card}:hover & {
    transform: scale(1.1) rotate(5deg);
    background: linear-gradient(135deg, #0A3B2D 0%, #4CAF50 100%);
    color: white;
    box-shadow: 0 8px 20px rgba(10, 59, 45, 0.2);

    svg {
      transform: scale(1.1);
    }
  }
`;

const CardTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #0A3B2D;
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 600;
  letter-spacing: -0.01em;
  transition: color 0.3s ease;

  ${Card}:hover & {
    color: #0A3B2D;
  }
`;

const CardText = styled.p`
  color: #4a6b63;
  line-height: 1.8;
  font-size: 1.05rem;
  font-weight: 400;
  transition: color 0.3s ease;

  ${Card}:hover & {
    color: #2a5e4f;
  }
`;

const ComingSoonSection = styled.div`
  margin-top: 5rem;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -2.5rem;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, #e0e9e6 50%, transparent 100%);
  }
`;

const ComingSoonTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 2rem;
  color: #0A3B2D;
  text-align: center;
  font-family: 'Space Grotesk', sans-serif;
  letter-spacing: 0.05em;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 2px;
    background: linear-gradient(90deg, #FFA726 0%, #FF6B35 100%);
    border-radius: 1px;
  }
`;

const ComingSoonCard = styled(Card)`
  max-width: 500px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  border: 2px dashed #e0e9e6;
  background: linear-gradient(135deg, #fafbfa 0%, #f5f7f5 100%);

  &::before {
    background: linear-gradient(135deg, rgba(255, 167, 38, 0.05) 0%, rgba(255, 107, 53, 0.05) 100%);
  }

  &:hover {
    border-color: #FFA726;
    box-shadow:
      0 20px 40px rgba(255, 167, 38, 0.15),
      0 8px 16px rgba(255, 107, 53, 0.1);
  }
`;

const ComingSoonBadge = styled.div`
  position: absolute;
  top: 12px;
  right: 20px;
  background: linear-gradient(135deg, #FFA726 0%, #FF6B35 100%);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  box-shadow: 0 4px 12px rgba(255, 167, 38, 0.3);
  z-index: 3;
`;

const ComingSoonIcon = styled(Icon)`
  margin: 0 auto 1.5rem;
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
  color: #FF6B35;

  ${ComingSoonCard}:hover & {
    background: linear-gradient(135deg, #FF6B35 0%, #FFA726 100%);
    color: white;
  }
`;

const ValueProposition = () => {
  return (
    <Section id="value-proposition">
      <Container>
        <SectionHeader>
          <SectionTitle>Our Value Proposition</SectionTitle>
          <SectionSubtitle>
            Empowering South African SMEs with innovative financial solutions designed for growth,
            efficiency, and long-term success in today's dynamic business landscape.
          </SectionSubtitle>
        </SectionHeader>

        <Grid>
          <Card>
            <Icon><PayrollIcon /></Icon>
            <CardTitle>Payroll Solutions</CardTitle>
            <CardText>
              Streamlined payroll services with real-time compliance support, comprehensive payslip generation,
              and secure tax management ensuring accurate and timely employee payments.
            </CardText>
          </Card>

          <Card>
            <Icon><ChartIcon /></Icon>
            <CardTitle>Smart Financial Management</CardTitle>
            <CardText>
              Take control of your cash flow with our intuitive platform that helps you track expenses,
              forecast revenue, and make data-driven decisions to optimize your financial health.
            </CardText>
          </Card>

          <Card>
            <Icon><HandshakeIcon /></Icon>
            <CardTitle>Local Market Expertise</CardTitle>
            <CardText>
              Built specifically for South African businesses, our solutions understand the unique
              challenges and opportunities of the local market, from load shedding to currency fluctuations.
            </CardText>
          </Card>

          <Card>
            <Icon><LightningIcon /></Icon>
            <CardTitle>Time-Saving Automation</CardTitle>
            <CardText>
              Automate repetitive financial tasks and focus on growing your business. Our smart tools
              handle everything from invoicing to tax compliance with South African regulations.
            </CardText>
          </Card>

          <Card>
            <Icon><ShieldIcon /></Icon>
            <CardTitle>Secure & Compliant</CardTitle>
            <CardText>
              Bank-level security and full compliance with South African financial regulations give you
              peace of mind that your business data is always protected.
            </CardText>
          </Card>

          <Card>
            <Icon><GlobeIcon /></Icon>
            <CardTitle>B2B Solutions</CardTitle>
            <CardText>
              We offer the greatest B2B solution because we combine unmatched industry expertise, tailored services, and scalable innovation to drive your business forward.
            </CardText>
          </Card>
        </Grid>

        <ComingSoonSection>
          <ComingSoonTitle>COMING SOON</ComingSoonTitle>
          <ComingSoonCard>
            <ComingSoonBadge>Coming Soon</ComingSoonBadge>
            <ComingSoonIcon><InvestmentIcon /></ComingSoonIcon>
            <CardTitle>Investment & Insurance Solutions</CardTitle>
            <CardText>
              Comprehensive investment and insurance solutions tailored for small businesses,
              helping you secure your company's financial future and protect your assets.
            </CardText>
          </ComingSoonCard>
        </ComingSoonSection>
      </Container>
    </Section>
  );
};

export default ValueProposition;
